import React from 'react';

import { DrawByProductId } from '../../../../features/draws/types';
import { useDrawStage } from '../../../../hooks/useDrawStage';
import type {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import { DrawFlow, PreOrderFlow, PublicReleaseFlow } from '../flows';
import { PublicSubscriptionCta } from './Public';
import { SoldOutSubscriptionCta } from './SoldOut';

type Props<T extends ProductPurchaseDetails> = {
  draw?: DrawByProductId;
  product: ProductType;
  purchasingController: ProductPurchasingController<T>;
};

export const DrawSubscriptionCta: React.FC<Props<ProductPurchaseDetails>> = ({
  draw,
  product,
  purchasingController,
}) => {
  const stage = useDrawStage(draw);

  if (!draw) {
    return (
      <PublicSubscriptionCta
        product={product}
        purchasingController={purchasingController}
      />
    );
  }

  switch (stage) {
    case 'SOLD_OUT':
      return (
        <SoldOutSubscriptionCta
          product={product}
          purchasingController={purchasingController}
        />
      );
    case 'DRAW':
    case 'DRAW_PRE_ORDER_CLOSED':
      return <DrawFlow draw={draw} product={product} />;
    case 'DRAW_PRE_ORDER_OPEN':
    case 'FCFS_PRE_ORDER_OPEN':
      return <PreOrderFlow draw={draw} product={product} />;
    case 'FCFS_PRE_ORDER_CLOSED':
      return (
        <PublicReleaseFlow
          draw={draw}
          product={product}
          purchasingController={purchasingController}
        />
      );
    default:
      return (
        <PublicSubscriptionCta
          product={product}
          purchasingController={purchasingController}
        />
      );
  }
};
